import { size } from 'polished';
import styled, { css } from 'styled-components';
import { AbstractButton } from '../../atoms/AbstractButton/AbstractButton';
import { Ease } from '../../../styles/easing';
import { TransitionDuration } from '../../../styles/variables';
import { typeStyle } from '../../../styles/typeStyle';
import { pseudo } from '../../../styles/helpers/pseudo';

type StyledButtonProps = {
  disabled?: boolean;
};

const disabledCss = css`
  cursor: not-allowed;
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.lighterGrey};
`;

export const StyledButtonContent = styled.span`
  ${typeStyle['call-to-action']};
  position: relative;

  &::after {
    ${pseudo()};
    ${size('2px', '100%')};
    left: 0;
    bottom: -0.0625rem;
    opacity: 0;
    transform: translateY(0.0625rem) scaleX(80%);
    transition-duration: ${TransitionDuration.Normal};
    transition-property: transform, opacity;
    transition-timing-function: ${Ease.EaseOut};
    background-color: ${({ theme }) => theme.color.black};
  }
`;

export const StyledButton = styled(AbstractButton)<StyledButtonProps>`
  height: 3.75rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  padding: 0 1.5rem;
  border-radius: ${({ theme }) => theme.defaultCssProps.borderRadius.normal};
  color: ${({ theme }) => theme.color.black};
  background-color: ${({ theme }) => theme.color.yellow};
  transition-duration: ${TransitionDuration.Normal};
  transition-property: background-color, color;
  transition-timing-function: ${Ease.EaseOut};

  ${(props) => props.disabled && disabledCss};

  &:not(:disabled):hover,
  &:not(disabled):hover,
  &:not(:disabled):focus,
  &:not(disabled):focus ${StyledButtonContent} {
    &::after {
      opacity: ${({ disabled }) => (disabled ? '0' : '1')};
      transform: translateY(0) scaleX(100%);
    }
  }
`;
